declare var Card: any;
namespace AgerLMS.WebSite {

    export interface ShippingAddressWidgetRequest {
    }

    @Serenity.Decorators.registerClass()
    export class ShippingAddressWidget extends Serenity.Widget<ShippingAddressWidgetRequest> {

        widgetKey: string = "ShippingAddress";
        widgetKey_: string = this.widgetKey + "_";
        idWidgetKey: string = "#" + this.widgetKey;
        idWidgetKey_: string = this.idWidgetKey + "_";
        modalStr : string = this.idWidgetKey + "Modal";
        modal: JQuery = $(this.modalStr);
        button: string = this.idWidgetKey + "Button";
        formSelector: string = this.idWidgetKey + "Form";

        openModalId : string = "#Open" + this.widgetKey + "Modal";

        addressId : string = this.widgetKey_ + "AddressId";
        cityId : JQuery = $(this.idWidgetKey_+ "CityId");
        districtId : JQuery = $(this.idWidgetKey_+ "DistrictId");
        neighbourhoodId : JQuery = $(this.idWidgetKey_+ "NeighbourhoodId");
        ShippingAddress : JQuery = $(this.idWidgetKey);
        entityId : number;

        constructor(element: JQuery, opt: ShippingAddressWidgetRequest) {
            super(element, opt);
            var self = this;
            var form = $(this.formSelector);

            this.bindValidate();
            this.loadUserAddressPanel(true);

            var cities = Q.getLookup<LMS.CitiesRow>("LMS.Cities");
            var data = cities.items.map(x => { return { id: x.Id, text: x.Name } });
            (self.cityId as any).select2({
                placeholder: "Şehir Seçiniz",
                allowClear: true,
                data: data,
                dropdownParent: self.modal
            });
            self.setSelectVal(self.cityId);

            self.cityId.on("change", function (e) {
                var cityId = $(this).val();
                var districts = Q.getLookup<LMS.DistrictsRow>("LMS.Districts").items.filter(x => x.CityId == cityId);
                var data = districts.map(x => { return { id: x.Id, text: x.Name } });
                
                self.districtId.empty();
                (self.districtId as any).select2({
                    placeholder: "İlçe Seçiniz",
                    allowClear: true,
                    data: data,
                    dropdownParent: self.modal
                });

                self.setSelectVal(self.districtId);
            });

            self.districtId.on("change", function (e) {
                var districtId = $(this).val();
                var neighbourhoods = Q.getLookup<LMS.NeighbourhoodsRow>("LMS.Neighbourhoods").items.filter(x => x.DistrictId == districtId);
                var data = neighbourhoods.map(x => { return { id: x.Id, text: x.Name } });

                self.neighbourhoodId.empty();
                (self.neighbourhoodId as any).select2({
                    placeholder: "Mahalle Seçiniz",
                    allowClear: true,
                    data: data,
                    dropdownParent: self.modal
                });
                self.setSelectVal(self.neighbourhoodId);
            });

            var formClear = function () {
                self.setSelectVal(self.cityId);
                self.setSelectVal(self.districtId);
                self.setSelectVal(self.neighbourhoodId);
                $(self.formSelector).find("input[name='Title']").val("");
                $(self.formSelector).find("textarea[name='Address1']").val("");
                $(self.formSelector).find("textarea[name='Address2']").val("");
                $(self.formSelector).find("input[name='ZipCode']").val("");
            }

            $(self.button).click(e => {
                e.preventDefault();

                if (!form.valid()) return;

                var entity = <LMS.AddressesRow>{};
                entity.Title = $(self.formSelector).find("input[name='Title']").val();
                entity.CityId = Q.toId($(self.formSelector).find("select[name='CityId']").val());
                entity.DistrictId = Q.toId($(self.formSelector).find("select[name='DistrictId']").val());
                entity.NeighbourhoodId = Q.toId($(self.formSelector).find("select[name='NeighbourhoodId']").val());
                entity.Address1 = $(self.formSelector).find("textarea[name='Address1']").val();
                entity.Address2 = $(self.formSelector).find("textarea[name='Address2']").val();
                entity.ZipCode = $(self.formSelector).find("input[name='ZipCode']").val();
                entity.Id = this.entityId;
                entity.IsDefaultShippingAddress = true;

                let onSuccess = (r : Serenity.SaveResponse, reload: boolean) => {
                    // window.location.href = Q.resolveUrl("~/Payment/Checkout");
                    SweetAlert.swal_success("Başarılı", "Adresiniz başarıyla kaydedildi.");
                    window.setTimeout(function () {
                        (self.modal as any).modal("hide");
                        self.loadUserAddressPanel(false, r.EntityId);
                    }, 100);
                    formClear();
                    if (reload) window.location.reload();
                };

                let onError = (r) => {
                    SweetAlert.swal_alert("HATA", r.Error.Message);
                };

                if (this.entityId)
                    LMS.AddressesService.Update({
                        Entity : entity
                    }, response => onSuccess(response, false),
                    {
                        onError: response => onError(response)
                    });
                else
                    LMS.AddressesService.Create({
                        
                        Entity : entity
                    }, response => onSuccess(response, true),
                    {
                        onError: response => onError(response)
                    });
            });

            $(this.openModalId).click(function (e) {
                e.preventDefault();
                self.loadModalWithId();
            });

            $(this.openModalId + "Edit").click(function (e) {
                e.preventDefault();
                let id = $(".user-selected-shipping-adress").data("id");
                self.loadModalWithId(id);
            });

            //eğer modal kapatılırsa formu temizle
            self.modal.on("hidden.bs.modal", function () {
                formClear();
                this.entityId = null;
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private setSelectVal(selectElement : JQuery, id : number = -1) {
            // try {
            //     selectElement.select2("val", id.toString());
            //     selectElement.trigger("change");
            // } catch {
                selectElement.val(id.toString());
                selectElement.trigger("change");
            // }
        }

        private loadUserAddressPanel(isFirstLoad: boolean = false, id : number = -1) {
            var self = this;
            if ($('#' + this.addressId).data('select2')) $('#' + this.addressId).select2('destroy');
            self.ShippingAddress.html("");
            $('#' + this.addressId).remove();
            var selectedId = id;
            LMS.AddressesService.GetLoggedUserList({ IncludeColumns: ["CityName", "DistrictName", "NeighbourhoodName", "Email", "MobilePhoneNumber"] }, response => {

                let userSelectedShippingAddress1 = (entity: LMS.AddressesRow)=> {
                    let div = $("<div class='user-selected-shipping-adress'></div>");
                    div.data("id", entity.Id);
                    $("input[name='shipping_addressId']").val(entity.Id);
                    if (entity.Email != null && entity.Email != "")
                    div.append("<div class='adress-content'>" + entity.Email + "</div>");
                    if (entity.MobilePhoneNumber != null && entity.MobilePhoneNumber != "")
                    div.append("<div class='adress-content'>" + entity.MobilePhoneNumber + "</div>");
                    div.append("<div class='adress-title'><b>" + entity.Title + "</b></div>");
                    if (entity.Address1 != null && entity.Address1 != "")
                    div.append("<div class='adress-content'>" + entity.Address1 + "</div>");
                    if (entity.Address2 != null && entity.Address1 != "")
                    div.append("<div class='adress-content'>" + entity.Address2 + "</div>");
                    if (entity.NeighbourhoodName != null && entity.NeighbourhoodName != "")
                    div.append("<div class='adress-content'>" + entity.NeighbourhoodName + " / " + entity.DistrictName + " / " + entity.CityName + "</div>");
                    if (entity.DistrictName != null && entity.DistrictName != "" && !(entity.NeighbourhoodName != null && entity.NeighbourhoodName != ""))
                    div.append("<div class='adress-content'>" + entity.NeighbourhoodName + " / " + entity.DistrictName + " / " + entity.CityName + "</div>");
                    if (!(entity.DistrictName != null && entity.DistrictName != ""))
                    div.append("<div class='adress-content'>" + entity.CityName + "</div>");
                    if (entity.ZipCode != null && entity.ZipCode != "")
                    div.append("<div class='adress-content'>PK : " + entity.ZipCode + "</div>");

                    return div;
                }

                let select = $("<select id='" + this.addressId + "' name='" + this.addressId + "' class='form-control .select2'></select>");
                select.append("<option value='-1'>Adres Seçiniz</option>");
                response.Entities.forEach(x => {
                    select.append("<option value='" + x.Id + "'>" + x.Title + "</option>");
                });
                self.ShippingAddress.before(select);
                select.on("change", function (e) {
                    let aId = $(this).val();
                    var address = response.Entities.filter(x => x.Id == aId);
                    if (address.length > 0) {
                        self.ShippingAddress.empty();
                        self.ShippingAddress.append(userSelectedShippingAddress1(address[0]));
                    }
                });

                
                if (isFirstLoad) {
                    let defaultShippingAddress = response.Entities.filter(x => x.IsDefaultShippingAddress == true);
                    if (defaultShippingAddress.length > 0) {
                        // self.ShippingAddress.append(userSelectedShippingAddress1(defaultShippingAddress[0]));
                        // self.setSelectVal(select, defaultShippingAddress[0].Id);
                        id = defaultShippingAddress[0].Id;
                    }
                }
                self.setSelectVal(select, id);
            });
        }

        private loadModalWithId(entityId?: number, callback?: (response: LMS.AddressesRow) => void) {
            var self = this;
            let isEntityIdNull = entityId == null || entityId == undefined;
            let openModal = (title?: string) => {
                let m = (self.modal as any);
                m.modal({ keyboard: false, backdrop: 'static' });
                m.modal("show");
                if (!isEntityIdNull)
                    m.find('.modal-title').text("Adres Düzenle[" + title + "]");
            }
            if (isEntityIdNull) openModal();
            else {
                this.entityId = entityId;
                SweetAlert.swal_loading("Lütfen bekleyiniz...");
                LMS.AddressesService.Retrieve({
                    EntityId: entityId,
                }, response => {
                    this.fillForm(response.Entity);
                    openModal(response.Entity.Title);
                    SweetAlert.swal_close();
                    if (callback) callback(response.Entity);
                }, {
                    onError: (e) => {
                        SweetAlert.swal_alert("Hata", e.Error.Message);
                    }
                });
            }
        }

        private fillForm(entity: LMS.AddressesRow) {
            var self = this;
            $(self.formSelector).find("input[name='Title']").val(entity.Title);
            $(self.formSelector).find("select[name='CityId']").val(entity.CityId.toString());
            $(self.formSelector).find("select[name='CityId']").trigger("change");
            if (entity.DistrictId)
            $(self.formSelector).find("select[name='DistrictId']").val(entity.DistrictId.toString());
            $(self.formSelector).find("select[name='DistrictId']").trigger("change");
            if (entity.NeighbourhoodId)
            $(self.formSelector).find("select[name='NeighbourhoodId']").val(entity.NeighbourhoodId.toString());
            $(self.formSelector).find("select[name='NeighbourhoodId']").trigger("change");
            $(self.formSelector).find("textarea[name='Address1']").val(entity.Address1);
            $(self.formSelector).find("textarea[name='Address2']").val(entity.Address2);
            $(self.formSelector).find("input[name='ZipCode']").val(entity.ZipCode);
        }

        private loadEntity(entityId: number, callback: (entity: LMS.AddressesRow) => void) {
            LMS.AddressesService.Retrieve({
                EntityId: entityId,
            }, response => {
                callback(response.Entity);
            }, {
                onError: (e) => {
                    SweetAlert.swal_alert("Hata", e.Error.Message);
                }
            });
        }

        private bindValidate() {
            var self = this;

            let r = {
                Title: {
                    required: true
                },
                CityId: {
                    required: true
                },
                DistrictId: {
                    required: true
                },
                Address1: {
                    required: true
                },
                ZipCode: {
                    required: true,
                    number: true,
                    maxlength: 5,
                    minlength: 5
                    
                }
            };
            let m = {
                Title: {
                    required: "* Adres başlığını girin."
                },
                CityId: {
                    required: "* Şehir seçin."
                },
                DistrictId: {
                    required: "* İlçe seçin."
                },
                Address1: {
                    required: "* Adres girin."
                },
                ZipCode: {
                    required: "* Posta kodu girin.",
                    number: "* Posta kodunu sayı olarak girin.",
                    maxlength: "* Posta kodu 5 haneli olmalıdır.",
                    minlength: "* Posta kodu 5 haneli olmalıdır."
                }
            };

            $(this.formSelector).validate({
                errorClass: "is-invalid",
                rules: r,
                messages: m
            });
        }
    }
}